<!--
/*******************************************************************************
*@ 컴포넌트명   : PersonalInfo0.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 조회 [개인]
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="corporation">
    <div class="scroll">
      <contents-header :bg-type="true" title="MPRS-01-01-02-01" description="MPRS-01-01-02-02" />
      <article class="contents">
        <div class="form">
          <!-- 고객명 -->
          <div class="form-row">
            <input-text
              ref="ovsesCustOcntryName"
              id="ovsesCustOcntryName"
              :value="RBF0409E40.ovsesCustOcntryName"
              disabled
              label-i18n="MPRS-01-01-02-03"
            />
          </div>
          <!-- 자택 전화번호 -->
          <div class="form-row">
            <input-text
              ref="owhusTelno"
              id="owhusTelno"
              :value="RBF0409E40.owhusTelno"
              disabled
              label-i18n="MPRS-01-01-02-04"
            />
          </div>
          <!-- 휴대폰 번호 -->
          <div class="form-row">
            <input-text
              ref="cphnNo"
              id="cphnNo"
              :value="RBF0409E40.cphnNo"
              disabled
              label-i18n="MPRS-01-01-02-05"
            />
          </div>
          <!-- 이메일 주소 -->
          <div class="form-row">
            <input-text
              ref="emad1"
              id="emad1"
              :value="RBF0409E40.emad1"
              disabled
              label-i18n="MPRS-01-01-02-06"
            />
          </div>
          <!-- 자택 주소 -->
          <div class="form-row">
            <div class="item-tit">{{ /*자택 주소*/ $t("MPRS-01-01-02-07") }}</div>
            <div class="item-desc">
              <input-text
                v-if="RBF0409E40.owhusNmad"
                ref="owhusNmad"
                id="owhusNmad"
                :value="RBF0409E40.owhusNmad"
                disabled
              />
              <input-text ref="owhusAddr1" id="owhusAddr1" :value="RBF0409E40.owhusAddr1" disabled />
              <input-text
                v-if="RBF0409E40.owhusAddr2"
                ref="owhusAddr2"
                id="owhusAddr2"
                :value="RBF0409E40.owhusAddr2"
                disabled
              />
              <input-text
                v-if="RBF0409E40.owhusAddr3"
                ref="owhusAddr3"
                id="owhusAddr3"
                :value="RBF0409E40.owhusAddr3"
                disabled
              />
            </div>
          </div>
          <!-- 회사 주소 -->
          <div class="form-row">
            <div class="item-tit">{{ /*회사 주소*/ $t("MPRS-01-01-02-08") }}</div>
            <div class="item-desc">
              <input-text
                v-if="RBF0409E40.coNmad"
                ref="coNmad"
                id="coNmad"
                :value="RBF0409E40.coNmad"
                disabled
              />
              <input-text ref="coAddr1" id="coAddr1" :value="RBF0409E40.coAddr1" disabled />
              <input-text
                v-if="RBF0409E40.coAddr2"
                ref="coAddr2"
                id="coAddr2"
                :value="RBF0409E40.coAddr2"
                disabled
              />
              <input-text
                v-if="RBF0409E40.coAddr3"
                ref="coAddr3"
                id="coAddr3"
                :value="RBF0409E40.coAddr3"
                disabled
              />
            </div>
          </div>
          <!-- 우편물 수신 -->
          <div class="form-row">
            <input-text
              ref="postSendAreaDstcd"
              id="postSendAreaDstcd"
              :value="$te(RBF0409E40.postSendAreaDstcd+'_우편발송지구분코드')?$t(RBF0409E40.postSendAreaDstcd+'_우편발송지구분코드'):''"
              disabled
              label-i18n="MPRS-01-01-02-09"
            />
          </div>
          <!-- 거래 Statement 우편발송 여부 -->
          <div v-if="siteCode===$config.SITECODE_OGAUC" class="form-row">
            <input-text
              ref="postSendYn"
              id="postSendYn"
              :value="$te(RBF0409E40.postSendYn+'_우편발송여부')?$t(RBF0409E40.postSendYn+'_우편발송여부'):''"
              disabled
              label-i18n="MPRS-01-01-02-11"
            />
          </div>
        </div>
        <div
          v-if="siteCode===$config.SITECODE_OGAUC"
          class="info info-etc"
        >※ {{ /*조회 > 거래내역조회 > Statement조회 에서 조회 후 인쇄할 수 있습니다.*/ $t("MPRS-01-01-02-13") }}</div>
      </article>
    </div>
    <div class="btn-area--full fixed">
      <button class="btn md gray" @click="goPrevStep">{{ /*뒤로*/ $t("MCOM-0000078") }}</button>
      <button class="btn md normal" @click="goNextStep">{{ /*수정*/ $t("MPRS-01-01-02-15") }}</button>
    </div>
  </section>
</template>
<script>
import Common from "@/components/basic/Common";
import { mapFields } from "vuex-map-fields";

export default {
  extends: Common,
  computed: {
    ...mapFields("admin/personalInfo", ["RBF0409E40", "RBF0409E40_data"]),
  },
  data() {
    return {};
  },
  mounted() {
    this.RBF0409E40Call();
  },
  methods: {
    RBF0409E40Call() {
      this.RBF0409E40_data = {};
      this.$post("/customer/cust/CustInfoInq", {}, this.RBF0409E40Suc);
    },
    RBF0409E40Suc(res) {
      this.RBF0409E40 = res.outItem;

      if (!this._.isNil(res.outItem.emad1)) {
        const email = res.outItem.emad1.split("@");
        this.RBF0409E40.emailId = email[0];
        this.RBF0409E40.emailAddress = email[1];
      }

      this.RBF0409E40.isPostSendYnAgree = this.RBF0409E40.postSendYn == "1" ? true : false;
    },
    goPrevStep() {
      this.$router.push({ name: "perInfoAuthentication" });
    },
    goNextStep() {
      this.$router.push({ name: "perInfoStep1" });
    },
  },
};
</script>